import { generateTestId } from "@client-shared";

export const setAppHeaderTestId = (identifier: string): string => generateTestId("AppHeader", identifier);
